import { render, staticRenderFns } from "./dual-button.vue?vue&type=template&id=19e4997f&"
import script from "./dual-button.component.ts?vue&type=script&lang=ts&"
export * from "./dual-button.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports